export const STORAGE_REPOSITORY_TYPE = {
  GCS: 'gcs',
  S3: 's3',
  FS: 'fs',
  HDFS: 'hdfs',
} as const;

export type StorageRepositoryType = (typeof STORAGE_REPOSITORY_TYPE)[keyof typeof STORAGE_REPOSITORY_TYPE];
export type CloudStorageRepositoryType = Extract<StorageRepositoryType, 'gcs' | 's3'>;
export type FileSystemRepositoryType = Extract<StorageRepositoryType, 'fs'>;
export type HadoopStorageRepositoryType = Extract<StorageRepositoryType, 'hdfs'>;

export type CloudStorageRepository = {
  name: string;
  bucket: string;
  base_path: string;
  type: CloudStorageRepositoryType;
};

export type FileSystemRepository = {
  name: string;
  location: string;
  type: FileSystemRepositoryType;
};

export type HadoopStorageRepository = {
  name: string;
  uri: string;
  path: string;
  load_defaults: boolean;
  type: HadoopStorageRepositoryType;
  conf: { [key: string]: string };
};

export type Repository = {
  repository: CloudStorageRepository | FileSystemRepository;
  ready: boolean;
  details: string | null;
};
